// extracted by mini-css-extract-plugin
module.exports = {"root":"az_H6b","certonaPartCard":"az_I6b","svgForOos":"az_J6b"};